import './LinkView.styles.css';
import { ConfirmDeleteButton } from '../confirm-delete-button';
import i18n from '../../utils/i18n.ts';

const LinkView = ({
  link,
  onDelete,
}: {
  link: { title: string; url: string };
  onDelete?: (title: string) => void;
}) => {
  const handleDelete = () => {
    if (onDelete) onDelete(link.title);
  };
  return (
    <div className="link-view-container">
      <div className="link-view-left">
        <div className="link-view-title">{link.title}</div>
        <div className="link-view-url">{link.url}</div>
      </div>
      {onDelete && (
        <div className="link-view-right">
          <ConfirmDeleteButton isIconButton title={i18n.t('common.link')} onSubmit={handleDelete} />
        </div>
      )}
    </div>
  );
};

export default LinkView;